export const catalogConfigs = {
  title: {
    default: "THOTH",
    ko: "토트",
  },
  langSet: ["ko", "en"],
  pageMap: [
    { name: "cover", outlets: ["cover", "index"] },
    { name: "company-about" },
    { name: "company-differntiation" },
    { name: "company-competitive" },
    { name: "company-business" },
    { name: "solution-intro" },
    { name: "solution-recycling-overview" },
    { name: "solution-recycling-dismantlebot-intro" },
    { name: "solution-recycling-dismantlebot-lineup" },
    { name: "solution-recycling-dismantlebot-custom", outlets: ["1", "2"] },
    { name: "solution-logistics-overview" },
    { name: "solution-logistics-flexipacker-intro" },
    { name: "solution-logistics-flexipacker-module" },
    { name: "solution-logistics-flexipacker-automation", outlets: ["1", "2", "3", "4", "5"] },
    { name: "solution-logistics-fruitpacker-intro" },
    { name: "solution-logistics-fruitpacker-module", outlets: ["1", "2", "3"] },
    { name: "solution-logistics-fruitpacker-lineup" },
    { name: "solution-custom-overview" },
    { name: "solution-custom-application" },
    { name: "technology-core" },
    { name: "technology-raaps-tech" },
    { name: "technology-raaps-solution" },
    { name: "service-one-stop" },
    { name: "service-provide" },
    { name: "service-center" },
    { name: "last" },
  ],
  autoplay: {
    delay: 4000,
    loop: true,
  },
  width: 1920,
  height: 1080,
  breakpoint: 767,
};

const ENV = process.env;
export const IS_DEV = ENV.REACT_APP_IS_DEV;
export const ROUTER_TYPE = ENV.REACT_APP_ROUTER_TYPE;
export const BASE_NAME = ENV.REACT_APP_BASE_NAME;
export const PUBLIC_URL = ENV.PUBLIC_URL;
export const IMG_URL = `${PUBLIC_URL}/images`;
